var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggYolk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#F49B2D;}\n\t.st2{fill:#EF7B22;}\n\t.st3{fill:#FABA4C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.42,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.12,149.93,60.73,184.22,103.42,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 103.76,
    cy: 107.7,
    rx: 43.79,
    ry: 29.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.76,125.15c-21.13,0-38.77-10.05-42.88-23.42c-0.59,1.93-0.91,3.93-0.91,5.97 c0,16.23,19.6,29.39,43.79,29.39c24.18,0,43.79-13.16,43.79-29.39c0-2.05-0.32-4.04-0.91-5.97 C142.53,115.1,124.89,125.15,103.76,125.15z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 116.75,
    cy: 94.01,
    rx: 13.89,
    ry: 5.03
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggYolk);
export default __webpack_public_path__ + "static/media/Egg_yolk.01cfe76d7b6cd93e1f0471eb393a1824.svg";
export { ForwardRef as ReactComponent };